import type { WorkflowStatus } from "@entrilia/shared/api/workflowTypes";
import type {
  AssignedEntityType,
  ChangeRequestChangeSetType,
  InvestorChangeRequestDetails,
} from "../../../api/types/workflowTypes";

const changeSetTypeLabels: Record<ChangeRequestChangeSetType, string> = {
  Investor: "Investor Details",
  BankAccount: "Bank Details",
  FundInvestorBankAccountAssignment: "Fund Assignment",
  InvestorMember: "Contact Access",
};

const assignedEntityTypesLabels: Record<AssignedEntityType, string> = {
  FundInvestor: "Fund Assignments",
};

export const formatChangeSetType = (changeSetType: ChangeRequestChangeSetType): string =>
  changeSetTypeLabels[changeSetType] ?? changeSetType;

export const formatAssignedEntityType = (assignedEntityType: AssignedEntityType): string =>
  assignedEntityTypesLabels[assignedEntityType] ?? assignedEntityType;

export const hasApprovalInfo = (workflowStatus: WorkflowStatus) => ["Completed", "Rejected"].includes(workflowStatus);

export const isV2ChangeRequest = (changeRequest: InvestorChangeRequestDetails): boolean => !!changeRequest.approvalId;

export const isChangeTypeWithNewValues = (changeSetType: ChangeRequestChangeSetType) => changeSetType === "BankAccount";
